import Model from "../Model";
import LegalInformation from "../invoice/LegalInformation";
import moment from "moment";

export default class Establishment extends Model {

    public uid!: Uuid;
    public name!: string;
    public defaultLegalInformationUid!: Uuid;
    public defaultLegalInformation!: LegalInformation;
    public permissions : string[]=[];
    public extra: any = {};

    get is_productRead_allowed():boolean{
        return this.check_permission("PRODUCT_READ");
    }
    get is_inventoryRead_allowed():boolean{
        return this.check_permission("INVENTORY_READ");
    }
    get is_inventoryValidation_allowed():boolean{
        return this.check_permission("INVENTORY_VALIDATION");
    }
    get is_employeeRead_allowed():boolean{
        return this.check_permission("EMPLOYEE_READ");
    }
    get is_employeeUpdate_allowed():boolean{
        return this.check_permission("EMPLOYEE_UPDATE");
    }

    get is_contractRead_allowed():boolean{
        return this.check_permission("CONTRACT_READ");
    }
    get is_contractUpdate_allowed():boolean{
        return this.check_permission("CONTRACT_UPDATE");
    }

    get is_turnoverTargetsRead_allowed():boolean{
        return this.check_permission("TURNOVER_READ");
    }

    get is_invoiceMailSend_allowed():boolean{
        return this.check_permission("INVOICE_MAIL_SEND");
    }

    get is_all_allowed():boolean{
        return this.check_permission("ALL");
    }

    private check_permission(value:string){
        for(let perm of this.permissions){
            if(perm===value|| perm==="ALL"){
                return true;
            }
        }
        return false;
    }
    /**
     * Construct a product from a javascript object of a json string
     * @param obj either a javascript object or a json string
     */
    constructor(obj: any) {
        super();
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Establishment.buildFromJson(this, obj);
    }

    /**
     * builds the class instance from a javascript object
     * @param instance this
     * @param json javascript object
     */
    private static buildFromJson(instance: any, json: any) {
        if (json) {
            for (let prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'lastUpdateDate' || prop === 'creationDate') {
                        instance[prop] = moment(json[prop]).toISOString();
                    } else if (prop === 'defaultLegalInformation') {
                        instance[prop] = new LegalInformation(json[prop]);
                    } else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    }

    //TODO: Do this function
    exportToJson() {
        let JSONEstablishment: any = {};

        JSONEstablishment.uid = this.uid;
        JSONEstablishment.name = this.name
        JSONEstablishment.defaultLegalInformationUid = this.defaultLegalInformationUid;
        JSONEstablishment.permissions = this.permissions;
        JSONEstablishment.extra = this.extra;

        return JSONEstablishment;
    }
}